// Application Properties Configuration
// API base URL - set via .env (REACT_APP_API_BASE_URL) or defaults below


//export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://68.178.169.227:8080';
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://tkdgroup.in';

//export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://springboot-demo-31.onrender.com';

// Role configuration used across the app
export const ROLE_SUPERVISOR = 'Supervisor';
export const ROLE_SUPERADMIN = 'Superadmin';

// Convenience list when you want to allow both
export const AUTHORIZED_ROLES = [ROLE_SUPERVISOR, ROLE_SUPERADMIN];

export const plantNames = [
  { 
    name: 'Plant1',
    value: 'Plant1',
    label: 'Plant1' // change to plant name
  }  
];